// Import Pages
import react, { useState, useEffect } from "react";
import React from "react";
import { useTranslation } from "react-i18next";

// Import Material UI
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Close from '@material-ui/icons/Close';


function CommonModal({ closeModal, save, variables, content, hideOpenMode }) {
    const { t } = useTranslation();

    const handleClose = () => {
        closeModal(false);
    };


    return (
        <Dialog open={true} >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title">
                    {t('CONTENT.CONFIGURATION-FORM.VARIABLES')}
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent style={{ width: "100%" }}>
                {content}
            </DialogContent>
            <DialogActions className="modal-actions">

                <Button
                    onClick={save}
                    variant="outlined"
                    style={{
                        backgroundColor: "rgb(63 128 195)",
                        borderRadius: "2px",
                        color: "#fff",
                        width: "25%",
                        // border: "none",
                        marginRight: "10%"
                    }}>
                    {t('CONTENT.MODAL.SAVE')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default CommonModal;